import script from "./rednote.vue?vue&type=script&setup=true&lang=js"
export * from "./rednote.vue?vue&type=script&setup=true&lang=js"

import "./rednote.vue?vue&type=style&index=0&id=980004de&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.member/src/fe-member/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-980004de"]])

export default __exports__